<template>
    <div>
        <sweet-modal icon="error" ref="errorModal" :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" blocking>
            <h3>Oh no</h3>
            <small class="text-center w-100 mt-3">
                {{errorMessage}}
            </small>
        </sweet-modal>
    </div>
</template>

<script>
    import { EventBus } from '../../event/event-bus.js';

    export default {
        data() {
            return {
                errorMessage: ""
            }
        },
        created() {
            EventBus.$on('emit-error', event => {
                this.errorMessage = event?.message ?? "Something didn't go right, please try again later.";
                this.$refs.errorModal.open();
            });
        },
    };
</script>
